package team.platforma.multiplatform_material_extension.ui.core.global_style.shape

import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Shape

object OutlineTextFieldShape {
    var shape: Shape? = null
}

@Composable
internal fun setOutlineTextFieldDefaultShape(): Shape {
    val global = OutlineTextFieldShape.shape
    val default = OutlinedTextFieldDefaults.shape
    return global ?: default
}